import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';

const SuperbetOfferRejected = ({ declineReason, isCounterOffer }) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  const popupTitle = isCounterOffer ? 'Your Counter Offer is rejected' : 'Your Superbet is rejected';

  return (
    <div className="popup-content popup-small superbet-popup">
      <h3 className="popup-title">{isCounterOffer ? t('Counter Offer') : t('Superbet')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{declineReason || t(popupTitle)}</p>
        <i className="icon-circle-close superbet-decline-icon" />
      </div>
      <button type="button" onClick={closePopup} className="popup-ok-button">
        {t('Ok')}
      </button>
    </div>
  );
};

SuperbetOfferRejected.propTypes = {
  declineReason: PropTypes.string,
  isCounterOffer: PropTypes.bool,
};

export default SuperbetOfferRejected;
